import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Paper,
  Button 
} from "@mui/material";
import { styled } from "@mui/system";
import { COLORS } from "../config/theme";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment-timezone";
import Modal from "./Modal";
import AgregarMensaje from "./AgregarMensaje";
import CustomTooltip from './CustomTooltip';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import ResponderMensaje from "./ResponderMensaje";

export const HistoricoMensajeriaTable = ({
  data,
  id_expediente,
  setReload,
  reload,
  usersList,
  oficinasList,
  internalUsersList,
  disabled = false,
  accionCrear = false,
}) => {

  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  console.log("ACCCION CREAR", accionCrear);
  
  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    height: "auto", // Establece una altura fija para el contenedor
    overflowY: "auto", // Habilita el scroll vertical si el contenido supera la altura
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows
      ? theme.shadows[3]
      : "0 3px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: theme.shape ? theme.shape.borderRadius : "4px",
  }));

  const StyledTableHead = styled(TableHead)(({ theme }) => ({
    backgroundColor: theme?.palette?.primary?.main || COLORS.SECONDARY,
    position: "sticky", // Fija la posición del encabezado
    //top: 60, // Desplazamiento desde la parte superior para ajustar el encabezado de la tabla
    zIndex: 1, // Asegura que el encabezado esté por encima del contenido de la tabla
    "& .MuiTableCell-head": {
      color: theme?.palette?.common?.white || "#fff",
      fontWeight: "bold",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme, index }) => ({
    backgroundColor:
      index % 2 === 0 ? theme?.palette?.action?.hover || "#f5f5f5" : "white",
  }));

  const HeaderContainer = styled("div")(({ theme }) => ({
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: theme?.palette?.background?.paper || "#fff",
    padding: 6
  }));

  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
  };

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "5px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  };

  const cellStyleBold = {
    ...cellStyle,
    fontWeight: "800",
  };

  const cellHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
  };

  const responder = (id, mensaje) => {
    console.log("Respondiendo al mensaje con ID:", id);
    setIsVisibleModal(true);
    setModalTitle("Responder mensaje");
    setModalContent(
      <ResponderMensaje
        setReload={setReload}
        reload={reload}
        setIsVisibleModal={setIsVisibleModal}
        mensaje={mensaje}
        respuesta={id}
      />
    );
  };

  const addNewMessage = () => {
    setIsVisibleModal(true);
    setModalTitle("Nuevo mensaje");
    setModalContent(
      <AgregarMensaje
        setReload={setReload}
        reload={reload}
        setIsVisibleModal={setIsVisibleModal}
        id_expediente={id_expediente}
        oficinasList={oficinasList}
        internalUsersList={internalUsersList}
        usersList={usersList}
      />
    );
  };

  return (
    <>
      <StyledTableContainer component={Paper} style={{ marginTop: "0px" }}>
      <HeaderContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center"
          }}
        >
          {/* <div
            style={{
              marginLeft: "auto",  // Esto empuja el div hacia la derecha
            }}
          >
            <AddIcon
              style={{
                fontSize: 20,
                fontWeight: "bold",
                color: accionCrear && !disabled ? COLORS.SECONDARY : COLORS.DISABLED,
                cursor: accionCrear && !disabled ? "pointer" : "not-allowed",
              }}
              onClick={accionCrear && !disabled ? addNewMessage : null}
            />
          </div> */}
        </div>
      </HeaderContainer>

      <div style={{ maxHeight: "420px", overflowY: "auto" }}>
        <Table style={tableStyle}>
          <StyledTableHead>
            <TableRow>
              <TableCell style={cellHeaderStyle}>Fecha</TableCell>
              <TableCell style={cellHeaderStyle}>De</TableCell>
              <TableCell style={cellHeaderStyle}>A</TableCell>
              <TableCell style={cellHeaderStyle}>Titulo</TableCell>
              <TableCell style={cellHeaderStyle}>Mensaje</TableCell>
              {/* <TableCell style={cellHeaderStyle}>Respuesta</TableCell>
              <TableCell style={cellHeaderStyle}>Respondido por</TableCell>
              <TableCell style={cellHeaderStyle}>Fecha respuesta</TableCell>
              <TableCell style={cellHeaderStyle}>Acción</TableCell> */}
            </TableRow>
          </StyledTableHead>
          {data.length > 0 ? (
            <TableBody>
              {data.map((row, index) => (
                <StyledTableRow key={index} index={index}>
                  <TableCell style={{ ...cellStyle, width: 40 }}>
                    {moment(row.fecha_env).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell style={{ ...cellStyle, width: 40 }}>
                    {row.usu_origen}
                  </TableCell>
                  <TableCell style={row.usu_destino ? cellStyle : cellStyleBold}>
                    {row.usu_destino
                      ? row.usu_destino
                      : `[${row.oficina_destino}]`}
                  </TableCell>
                  <TableCell style={{ ...cellStyle, cursor: "pointer" }}>
                    {row.titulo?.length > 200 ? (
                      <CustomTooltip title={row.titulo} placement="left-start">
                        <span>{row.titulo.slice(0, 200)}...</span>
                      </CustomTooltip>
                    ) : (
                      row.titulo
                    )}
                  </TableCell>
                  <TableCell style={{ ...cellStyle, cursor: "pointer" }}>
                    {row.mensaje?.length > 200 ? (
                      <CustomTooltip title={row.mensaje} placement="left-start">
                        <span>{row.mensaje.slice(0, 200)}...</span>
                      </CustomTooltip>
                    ) : (
                      row.mensaje
                    )}
                  </TableCell>
                  {/* <TableCell style={{ ...cellStyle, cursor: "pointer" }}>
                    {row.respuesta?.length > 200 ? (
                      <CustomTooltip title={row.respuesta} placement="left-start">
                        <span>{row.respuesta.slice(0, 200)}...</span>
                      </CustomTooltip>
                    ) : (
                      row.respuesta
                    )}
                  </TableCell>       
                  <TableCell style={{ ...cellStyle, cursor: "pointer" }}>
                    { row.respuesta_usuario }
                  </TableCell>  
                  <TableCell style={{ ...cellStyle, cursor: "pointer" }}>
                    {row.respuesta_fec ?
                      (
                        moment(row.respuesta_fec).format("DD/MM/YYYY HH:mm")
                      ): ("--/--/----")}
                  </TableCell>                                             
                  <TableCell style={{ ...cellStyle, cursor: "pointer" }}>
                    {row.conversa === 1 ? (
                      <Button
                        variant="text"
                        color="primary"
                        size="small"
                        onClick={() => responder(row.id, row.mensaje)}
                        disabled={row.respuesta}
                        style={{
                          marginLeft: "10px",
                          textTransform: "none", // Evitar que el texto sea mayúsculas
                          padding: "4px 8px", // Ajustar tamaño del botón
                        }}
                      >
                        Responder
                    </Button>
                    ) : (
                      ""
                    )}
                  </TableCell>                   */}
                </StyledTableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={5}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
                    Sin datos
                  </span>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </div>

      </StyledTableContainer>
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </>
  );
};
